import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

export default function TermsPage() {
    const { t } = useTranslation();
    const sections = t('terms.sections', { returnObjects: true });

    return (
        <div className="legal-page">
            <h1>{t('terms.title')}</h1>
            <p className="legal-subtitle">{t('terms.updated')}</p>
            {sections.map((section) => (
                <section key={section.heading}>
                    <h2>{section.heading}</h2>
                    {section.paragraphs.map((paragraph, i) => (
                        <p key={i}>{paragraph}</p>
                    ))}
                </section>
            ))}
        </div>
    );
}
